import type { InjectionKey } from 'vue'
import type { BreadcrumbProps } from '@bigin/components/breadcrumb'

export const breadcrumbKey: InjectionKey<BreadcrumbProps> =
  Symbol('breadcrumbKey')
